export default __webpack_public_path__ + "static/media/logo-mcard.89501a63.png";